/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Warning_Device_TiltedInputs */

const en_us2_body_assessment_warning_device_tilted = /** @type {(inputs: Body_Assessment_Warning_Device_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The phone was tilted close to the accepted limit. Next time, stand it upright, below navel height.`)
};

const pt_br2_body_assessment_warning_device_tilted = /** @type {(inputs: Body_Assessment_Warning_Device_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O celular estava inclinado perto do limite aceito. Na próxima vez, apoie o celular na vertical, abaixo do umbigo.`)
};

const es_419_body_assessment_warning_device_tilted = /** @type {(inputs: Body_Assessment_Warning_Device_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El teléfono estaba inclinado cerca del límite aceptado. La próxima vez, apóyalo en vertical, por debajo de la altura del ombligo.`)
};

const pt_pt2_body_assessment_warning_device_tilted = /** @type {(inputs: Body_Assessment_Warning_Device_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O telemóvel estava inclinado perto do limite aceite. Da próxima vez, apoia o telemóvel na vertical, abaixo do umbigo.`)
};

const fr_fr2_body_assessment_warning_device_tilted = /** @type {(inputs: Body_Assessment_Warning_Device_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le téléphone était incliné près de la limite acceptée. La prochaine fois, pose-le bien vertical, sous la hauteur du nombril.`)
};

const de_de2_body_assessment_warning_device_tilted = /** @type {(inputs: Body_Assessment_Warning_Device_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Handy war nah an der zulässigen Grenze geneigt. Stell es nächstes Mal aufrecht hin, unterhalb der Nabelhöhe.`)
};

const it_it2_body_assessment_warning_device_tilted = /** @type {(inputs: Body_Assessment_Warning_Device_TiltedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il telefono era inclinato vicino al limite accettato. La prossima volta, mettilo in verticale, sotto l'altezza dell'ombelico.`)
};

/**
* | output |
* | --- |
* | "The phone was tilted close to the accepted limit. Next time, stand it upright, below navel height." |
*
* @param {Body_Assessment_Warning_Device_TiltedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_warning_device_tilted = /** @type {((inputs?: Body_Assessment_Warning_Device_TiltedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Warning_Device_TiltedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_warning_device_tilted(inputs)
	if (locale === "es-419") return es_419_body_assessment_warning_device_tilted(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_warning_device_tilted(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_warning_device_tilted(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_warning_device_tilted(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_warning_device_tilted(inputs)
	return en_us2_body_assessment_warning_device_tilted(inputs)
});
export { body_assessment_warning_device_tilted as "body-assessment.warning.device_tilted" }